import React, { useEffect } from "react";
import { connect } from "react-redux";

import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex
} from "../../../redux/actions/menuActions";
import Menu from "../Menu";
import LuccaAttendances from "./LuccaAttendances";

const LuccaAttendancesContainer = props => {
  useEffect(() => {
    props.setMenuTopIndex("devs");
    props.setMenuLeftContent(Menu);
    props.setMenuLeftIndex("luccaattendances");
    props.setMenuLeftItemIndex("");
  }, []);
  return <LuccaAttendances {...props} />;
};

const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LuccaAttendancesContainer);



// WEBPACK FOOTER //
// src/pages/devs/lucca_attendances/LuccaAttendances.container.js